import { getGameConfig } from '../../../config/gameConfig';
import { RESOURCE_KEYS } from '../constants/resourceKeys';
import type { ResourceKey, SettlementResourceStats } from '../types';

export function createResourceStats(window: number): SettlementResourceStats {
    const buildBuckets = () =>
        RESOURCE_KEYS.reduce(
            (acc, key) => {
                acc[key] = new Array(window).fill(0);
                return acc;
            },
            {} as Record<ResourceKey, number[]>,
        );
    return {
        window,
        index: 0,
        tick: -1,
        produced: buildBuckets(),
        consumed: buildBuckets(),
    };
}

export function getResourceStatsWindow(config: ReturnType<typeof getGameConfig>): number {
    return Math.max(1, Math.round(config.time.ticksPerMinute * config.ui.storageStatsMinutes));
}
